var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOven = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "oven_svg__a",
  d: "M0 29h22.379V0H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M9.69 34.5h21V11.8h-21z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M11.99 27.5h16.2v-9h-16.2z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9 6)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M.69 24.1h21z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "oven_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#oven_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M.69 10.1h21V5.8h-21z",
  mask: "url(#oven_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M4.59 7.8a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM8.89 7.8a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM13.29 7.8a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM17.69 7.8a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM19.89.5H2.49L.69 6h21zM4.59 15.2h12.8M4.59 18.5h12.8",
  mask: "url(#oven_svg__b)"
})))));
export default SvgOven;